export default __webpack_public_path__ + "static/media/long-term-investing.08488eec.png";